import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GoogleDriveLoginComponent } from '@googleDriveAuthConfig/components/google-drive-login/google-drive-login.component';
import { AdminGuard } from './modules/core/guards/admin.guard';
import { AuthGuard } from './modules/core/guards/auth.guard';
import { LoggedGuard } from './modules/core/guards/logged.guard';
import { GoogleDriveAuthGuard } from './modules/google-drive-auth-config/guards/google-drive-auth.guard';

const routes: Routes = [
  {
    path: "dashboard",
    loadChildren: () => import("./modules/dashboard/dashboard.module").then(m => m.DashboardModule),
    canActivate: [AuthGuard],
    canLoad: [AuthGuard]
  },
  {
    path: "statistics",
    loadChildren: () => import("./modules/statistics/statistics.module").then(m => m.StatisticsModule),
    canActivate: [AuthGuard],
    canLoad: [AuthGuard]
  },
  {
    path: "device",
    loadChildren: () => import("./modules/device-details/device-details.module").then(m => m.DeviceDetailsModule),
    canActivate: [AuthGuard],
    canLoad: [AuthGuard]
  },
  {
    path: "admin",
    loadChildren: () => import("./modules/admin/admin.module").then(m => m.AdminModule),
    canActivate: [AdminGuard],
    canLoad: [AdminGuard]
  },
  {
    path: "timeline",
    loadChildren: () => import("./modules/timeline/timeline.module").then(m => m.TimelineModule),
    canActivate: [AuthGuard],
    canLoad: [AuthGuard]
  },
  {
    path: "teams",
    loadChildren: () => import("./modules/teams/teams.module").then(m => m.TeamsModule),
    canActivate: [AuthGuard],
    canLoad: [AuthGuard]
  },
  {
    path: "settings",
    loadChildren: () => import("./modules/settings/settings.module").then(m => m.SettingsModule),
    canActivate: [AuthGuard],
    canLoad: [AuthGuard]
  },
  {
    path: "shelf",
    loadChildren: () => import("./modules/shelf/shelf.module").then(m => m.ShelfModule),
    canActivate: [AuthGuard],
    canLoad: [AuthGuard]
  },
  {
    path: "printouts",
    loadChildren: () => import("./modules/prints/prints.module").then(m => m.PrintsModule),
    canActivate: [AuthGuard],
    canLoad: [AuthGuard]
  },
  {
    path: "streams",
    loadChildren: () => import("./modules/multi-stream/multi-stream.module").then(m => m.MultiStreamModule),
    canActivate: [AuthGuard],
    canLoad: [AuthGuard]
  },
  // {
  //   path: "vouchers",
  //   loadChildren: () => import("./modules/vouchers/vouchers.module").then(m => m.VouchersModule),
  //   canActivate: [AuthGuard],
  //   canLoad: [AuthGuard]
  // },
  {
    path: "subscription",
    loadChildren: () => import("./modules/subscription/subscriptions.module").then(m => m.SubscriptionsModule),
    canActivate: [AuthGuard],
    canLoad: [AuthGuard]
  },
  {
    path: "myFiles",
    loadChildren: () => import("./modules/my-files/my-files.module").then(m => m.MyFilesModule),
    canActivate: [AuthGuard, GoogleDriveAuthGuard],
    canLoad: [AuthGuard]
  },
  // {
  //   path: "googleDriveLogin",
  //   component: GoogleDriveLoginComponent,
  //   canActivate: [AuthGuard],
  //   canLoad: [AuthGuard]
  // },
  {
    path: "",
    canLoad: [LoggedGuard],
    canActivate: [LoggedGuard],
    loadChildren: () => import("./modules/landing-page/landing-page.module").then(m => m.LandingPageModule)
  },
  {
    path: "account",
    canLoad: [LoggedGuard],
    canActivate: [LoggedGuard],
    loadChildren: () => import("./modules/account/account.module").then(m => m.AccountModule)
  },
  {
    path: "**",
    redirectTo: "/dashboard",
    pathMatch: "full"
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
